import { useRecoDialog } from "@/core/composables/useRecoDialog";
import GlobalStatsDialog from "@/modules/recruitment/components/GlobalStatsDialog.vue";

export const useGlobalStatsDialog = () => {
  const dialog = useRecoDialog();

  const open = () => {
    dialog.open(GlobalStatsDialog, {});
  };

  return {
    open,
  };
};
